import React from 'react';
import { IPhoneFrame } from '@yme/assets/images';
import { Image } from '@yme/atoms/image';
import { MobileDeviceFrameBg, MobileImagePreview, MobileFrameInnerStyled, } from './AppMobileFrameStyled';
import { DEFAULT_IMAGE_PROPS } from './constants';
export function AppMobileFrame({ appImage }) {
    if (!appImage?.src) {
        return null;
    }
    const imageProps = {
        ...DEFAULT_IMAGE_PROPS,
        ...appImage,
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(MobileFrameInnerStyled, null,
            React.createElement(MobileImagePreview, null,
                React.createElement(Image, { ...imageProps }))),
        React.createElement(MobileDeviceFrameBg, { bgFrame: IPhoneFrame })));
}
AppMobileFrame.displayName = 'AppMobileFrame_Component';
